import React from 'react';
import {FormattedMessage} from 'react-intl';

export default class FormField extends React.Component {
    static propTypes = {
        field: React.PropTypes.object.isRequired,
        type: React.PropTypes.string.isRequired,
        message: React.PropTypes.object.isRequired,
        divClass: React.PropTypes.string,
        required: React.PropTypes.bool
    };

    static renderHint(hint) {
        return (
            <div className="hint hint--error">
                <FormattedMessage {...hint}/>
            </div>
        );
    }

    render() {
        const {message, type, field, divClass, required, joinError, msg} = this.props;

        const notRequiredLabelClass = 'login--form__label form__label';
        const requiredLabelClass = 'login--form__label form__label form__label__required';
        const inputClass = 'login--form__control form__control';

        const labelClass = required ? requiredLabelClass : notRequiredLabelClass;

        const rowClass = divClass ? divClass : 'form__row';

        return (
            <div className={rowClass}>
                <label className={labelClass}>
                    <FormattedMessage {...message}/>
                </label>
                <input type={type} className={inputClass} {...field} />
                {field.touched && field.error && FormField.renderHint(field.error)}
                {joinError && joinError === -2 && !field.error && FormField.renderHint(msg)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/FormField.jsx